import { Y42AssetStatus } from '@y42/json-schema';

export interface AssetStatusToUiModel {
  label: string;
  id: Y42AssetStatus;
  logo: string;
  color: string;
  backgroundColor: string;
}

export const AssetStatusToUI: Record<Y42AssetStatus, AssetStatusToUiModel> = {
  [Y42AssetStatus.Verified]: {
    label: 'Verified',
    id: Y42AssetStatus.Verified,
    logo: 'assets/images/asset-status-icons/asset-verified.svg',
    color: 'var(--green-600)',
    backgroundColor: 'var(--green-100)',
  },
  [Y42AssetStatus.Deprecated]: {
    label: 'Deprecated',
    id: Y42AssetStatus.Deprecated,
    logo: 'assets/images/asset-status-icons/asset-deprecated.svg',
    color: 'var(--yellow-800)',
    backgroundColor: 'var(--yellow-100)',
  },
  [Y42AssetStatus.Draft]: {
    label: 'Draft',
    id: Y42AssetStatus.Draft,
    logo: 'assets/images/asset-status-icons/asset-draft.svg',
    color: 'var(--gray-600)',
    backgroundColor: 'var(--gray-100)',
  },
  [Y42AssetStatus.Issue]: {
    label: 'Issue',
    id: Y42AssetStatus.Issue,
    logo: 'assets/images/asset-status-icons/asset-issue.svg',
    color: 'var(--red-600)',
    backgroundColor: 'var(--red-100)',
  },
  [Y42AssetStatus.NoStatus]: {
    label: 'No status',
    id: Y42AssetStatus.NoStatus,
    logo: 'assets/images/asset-status-icons/asset-no-status.svg',
    color: 'var(--gray-600)',
    backgroundColor: 'var(--gray-100)',
  },
};
